import {checkActionPermission, checkPermission} from "../../core/routes/RouteValidator";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import {useEffect, useState} from "react";
import $ from "jquery";
import {toast} from "react-hot-toast";
import XConstants from "../../core/config/Constants";
import {CustomerService} from "./Service";

const ManageCustomers = () => {
    const [service] = useState(new CustomerService());
    const [type, setType] = useState('Customer');
    const navigate = useNavigate();
    const location = useLocation();
    const user = useSelector((state: any) => state.auth);
    const company = useSelector((state: any) => state.company);

    const getItems = () => {
        try {
            $('#items').DataTable().destroy();
        } catch (e) {
            console.log(e);
        }
        let token = localStorage.getItem('token');
        $('#items').DataTable({
            lengthMenu: [10, 20, 50, 100, 500, 1000],
            pageLength: 100,
            processing: true,
            serverSide: true,
            columnDefs: [
                {

                    "render": function (data, type, row) {
                        if (data) {
                            return `<img src="${data}" alt="${row[2]}" style="border-radius: 50%;object-fit: cover; width: 50px; height: 50px" />`;
                        } else {
                            return `<img src="https://ui-avatars.com/api/?background=4F6F52&color=fff&name=${row[2]}&size=40&rounded=true"  alt="${row[2]}" width="50" height="50" />`;
                        }
                    },
                    "createdCell": (td, cellData, rowData, row, col) => {

                    },
                    "targets": 1
                },
                {

                    "render": function (data: string, type: any, row: any) {
                        if (data === 'Active') {
                            return `<p class="badge bg-success p-2 rounded-3">Active</p>`;
                        } else {
                            return `<p class="badge bg-danger p-2 rounded-3">Inactive</p>`;
                        }
                    },
                    "targets": 5
                },
                {

                    "render": function (data: any, type: any, row: string[]) {
                        if (row[5] === 'Active') {
                            return `<button class="btn btn-danger">Deactivate</button>`;
                        } else {
                            return `<button class="btn btn-success">Activate</button>`;
                        }
                    },
                    "createdCell": (td: any, cellData: any, rowData: any, row: any, col: any) => {
                        $(td).click(async (e: any) => {
                            let allowed = checkActionPermission(user, company, 'update')
                            if (!allowed) {
                                toast.error("You don't have permission to perform this action", {});
                                return;
                            }
                            const status = rowData[5] === 'Active' ? 'Inactive' : 'Active'
                            const res = await service.update(rowData[7], {
                                status: status
                            });
                            if (res) {
                                toast.success(`${type} updated successfully`, {});
                                getItems();
                            }
                        })
                    },
                    "targets": 7
                },
                {

                    "render": function (data: any, type: any, row: any) {
                        return `<button class="btn btn-primary">Details</button>`;
                    },
                    "createdCell": (td: any, cellData: any, rowData: any, row: any, col: any) => {
                        $(td).click((e: any) => {
                            navigate(`${location.pathname}/details/${cellData}`);
                        })
                    },
                    "targets": 8
                },
                {

                    "render": function (data: any, type: any, row: any) {
                        return `<button class="btn btn-danger">Delete</button>`;
                    },
                    "createdCell": (td: any, cellData: any, rowData: any, row: any, col: any) => {
                        $(td).click(async (e: any) => {
                            let allowed = checkActionPermission(user, company, 'delete')
                            if (!allowed) {
                                toast.error("You don't have permission to perform this action", {});
                                return;
                            }
                            const res = await service.update(rowData[9], {
                                deleted: true
                            });
                            if (res) {
                                toast.success(`${type} deleted successfully`, {});
                                getItems();
                            }
                        })
                    },
                    "targets": 9
                },
            ],
            ajax: {
                url: `${XConstants.baseUrl}/company/customer/list`,
                type: 'POST',
                contentType: 'application/json',
                headers: {
                    'Authorization': token,
                },
                data: function(d: any) {
                    return JSON.stringify({
                        ...d,
                        type: type,
                    });
                },
            },
        });
    };

    useEffect(() => {
        getItems();
    }, [type]);

    useEffect(() => {
        if (window.location.pathname.includes('customers')) {
            setType('Customer');
        } else if (window.location.pathname.includes('vendors')) {
            setType('Vendor');
        } else if (window.location.pathname.includes('transporters')) {
            setType('Transporter');
        }
    }, [window.location.pathname]);

    const exportCsv = async () => {
        toast.loading('Creating report...');
        const url = await service.download({
            type: type,
        });

        if (url) {
            window.open(url);
        }
    }

    const bulkAdd = async (file: any) => {
        toast.loading('Uploading...');
        const res = await service.upload(file, {
            type: type,
        });
        if (res) {
            toast.success(`${type}s added successfully`, {});
            getItems();
        }
        // Reset the file input
        document.getElementById('bulkAdd')?.setAttribute('type', 'text');
        document.getElementById('bulkAdd')?.setAttribute('type', 'file');
    }

    return (
        <>
            <div className="page-header">
                <div className="content-page-header">
                    <h5>{type}s</h5>
                    <div className="list-btn">
                        <ul className="filter-list">
                            <li onClick={exportCsv}>
                                <div
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Download"
                                >
                                    <a
                                        href="#"
                                        className="btn-filters"
                                        aria-expanded="false"
                                    >
              <span>
                <i className="fe fe-download"/>
              </span>
                                    </a>
                                </div>
                            </li>
                            {(checkPermission(user, company, `/${type.toLowerCase()}s/add`)) && <li>
                                <Link className="btn btn-primary" to={`#`} onClick={() => {
                                    console.log('click');
                                    document.getElementById('bulkAdd')?.click();
                                }}>
                                    <i className="fa fa-upload me-2" aria-hidden="true"/>
                                    Bulk add {type}
                                </Link>
                                <input type="file" accept=".xlsx" id="bulkAdd" style={{display: 'none'}} onChange={(e) => {
                                    // @ts-ignore
                                    const file = e.target.files[0];
                                    if (file) {
                                        bulkAdd(file);
                                    }
                                }}/>
                            </li>}
                            {(checkPermission(user, company, `/${type.toLowerCase()}s/add`)) && <li>
                                <Link className="btn btn-primary" to={`/${type.toLowerCase()}s/add`}>
                                    <i className="fa fa-plus-circle me-2" aria-hidden="true"/>
                                    Add {type}
                                </Link>
                            </li>}
                        </ul>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="card col-12">
                    <div className="card-body w-100">
                        <div className="table-responsive w-100">
                            <table
                                id="items"
                                className="table datatable  w-100"
                            >
                                <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>Profile Pic</th>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Phone Number</th>
                                    <th>Status</th>
                                    <th>Added Date</th>
                                    <th>Change Status</th>
                                    <th>Edit</th>
                                    <th>Delete</th>
                                </tr>
                                </thead>
                                <tbody>
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
}

export default ManageCustomers;
